import { Route, Switch } from 'react-router';
import { appMenuRoutes } from '../constants';



export const AppMenuRoutes = () => {

  return (
		<Switch>
			{
				[appMenuRoutes.map((route, index) => {
					return (
						<Route 
							key={index}
							path={route.path}
							exact={route.exact}
							render={() => <route.component />} />													
					)
					})					
				]
			}
		</Switch>
	);
}
